<template>
  <div>
    <a-modal v-model="visible" title="Event info" @cancel="handleCancel">
      <template slot="footer">
        <button class="btn" key="back" @click="handleCancel">Close</button>
      </template>

      <a-spin :spinning="spining">
        <div class="row" v-if="eventData">
          <div class="col-md-12 mb-2">
            <span class="font-weight-bold mr-3">Titile:</span>{{ eventData.title }}
          </div>
          <div class="col-md-12 mb-2">
            <span class="font-weight-bold mr-3">Description:</span>{{ eventData.description }}
          </div>
          <div class="col-md-6 mb-2">
            <span class="font-weight-bold mr-3">Event Type:</span>{{ findGlobalDataName(eventTypes, eventData.event_type) }}
          </div>
          <div class="col-md-2 col mb-2">
            <a-tag color="blue" v-if="eventData.end_date">{{ eventData.end_date ? 'All day': '' }}</a-tag>
          </div>
          <div class="col-md-2 col mb-2">
            <a-tag color="blue">{{ eventData.in_attendance ? 'Working day' : 'Holiday' }}</a-tag>
          </div>
          <div class="col-md-2 col mb-2">
            <a-tag color="blue" v-if="eventData.weekend">{{ eventData.weekend ? 'Weekend' : '' }}</a-tag>
          </div>
          <div class="col-md-6 mb-2">
            <span class="font-weight-bold mr-3">Start Date:</span>{{ moment(eventData.start_date).format(dateFormat) }}
          </div>
          <div class="col-md-6 mb-2">
            <span class="font-weight-bold mr-3">Start Time:</span>{{ eventData.start_time ? moment(eventData.start_time, 'HH:mm:ss').format(timeFormat) : '' }}
          </div>
          <div class="col-md-6 mb-2" v-if="eventData.end_date">
            <span class="font-weight-bold mr-3">End Date:</span>{{ moment(eventData.end_date).format(dateFormat) }}
          </div>
          <div class="col-md-6 mb-2" v-if="eventData.end_time">
            <span class="font-weight-bold mr-3">End Time:</span>{{ moment(eventData.end_time, 'HH:mm:ss').format(timeFormat) }}
          </div>
          <div class="col-md-12 mb-2" v-if="eventData.holiday_working_days && eventData.holiday_working_days.length">
            <span class="font-weight-bold mr-3">Working Days (Staff):</span>
            <a-tag v-for="h in eventData.holiday_working_days" :key="h.date" color="blue">
              {{ moment(h.date, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
            </a-tag>
          </div>
          <div class="col-md-6 mb-2">
            <span class="font-weight-bold mr-3">Session:</span>{{ eventData.session.name }}
          </div>
          <div class="col-md-3 mb-2">
            <span class="font-weight-bold mr-3">Class:</span>
            {{ eventData.school_class ? eventData.school_class.name : 'All' }}
          </div>
          <div class="col-md-3 mb-2">
            <span class="font-weight-bold mr-3">Section:</span>
            {{ eventData.section ? eventData.section.name : 'All' }}
          </div>
          <div class="col-md-6 mb-2">
            <span class="font-weight-bold mr-3">Target Audiance:</span>{{ findGlobalDataName(targetAudianceTypes, eventData.target_audience) }}
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'

import { eventTypes, targetAudianceTypes } from '@/services/globaldata'

export default {
  name: 'SingleCalendarEvent',
  mounted: function() {
    this.$eventBus.$on('openCalendarEventSingleViewModal', this.showModal)
  },
  computed: {

  },
  watch: {

  },
  data: function() {
    return {
      spining: false,
      visible: false,
      eventData: null,
      eventTypes,
      targetAudianceTypes,
      dateFormat: 'DD-MM-YYYY',
      timeFormat: 'hh:mm a',
    }
  },
  methods: {
    moment,
    showModal(event) {
      this.visible = true
      this.eventId = event.id
      this.getEvent()
    },
    handleTimePickerOpenChange(open) {
      this.open = open
    },
    getEvent: function() {
      this.spining = true
      this.$http.get(`/api/calendar/${this.eventId}`)
        .then(({ data }) => {
          this.spining = false
          this.eventData = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    findGlobalDataName(globalObject, value) {
      const data = find(globalObject, { value: value })
      return data.name
    },
    handleCancel(e) {
      this.visible = false
      this.eventData = null
    },
  },
}
</script>
